Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<label class="control-label">' +
((__t = ( ctx.t(ctx.component.label) )) == null ? '' : __t) +
'</label><br>\n<button lang=\'en\' class=\'btn btn-light btn-md open-modal-button\' ref=\'openModal\'>\n  ' +
((__t = ( ctx.previewText )) == null ? '' : __t) +
'\n</button>\n';
return __p
}